import './App.css';
import {Routes, Route, Router, BrowserRouter} from "react-router-dom";
import Home from "./pages/Home";
import {ModalProvider} from "./components/ModalContext";
import "./api";
import PurchaseTicket from "./pages/PurchaseTicket";
import Login from "./pages/Profile/Login";
import ModalContainer from "./components/ModalContainer";
import MushroomAi from "./pages/Mushroom/MushroomAi";
import MushroomGrowth from "./pages/Mushroom/MushroomGrowth";

function App() {
    return (
        <ModalProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/buy" element={<PurchaseTicket/>}/>
                    <Route path="/buy/:id" element={<PurchaseTicket/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/mushroom-growth-table" element={<MushroomGrowth/>}/>
                    <Route path="/ai" element={<MushroomAi/>}/>
                </Routes>
            </BrowserRouter>
            <ModalContainer/>

        </ModalProvider>
    );
}

export default App;
